module.exports = __webpack_public_path__ + "static/assets/e1efa37165e540591a16381fb0df2e2a.png";